import { all, put, select, takeLatest } from 'redux-saga/effects';
import { map, isNil } from 'lodash';
import { actionTypes } from './actions';
import { dataToLoadPersonalData } from 'modules/Profile/components/PersonalData/selectors';
import { startRequest as startLoadPersonalData } from 'modules/Profile/redux/personalData/actions';
import { getAvatar } from 'modules/App/redux/avatar/actions';
import { startRequest as startReadOnlyRequest } from 'modules/Profile/redux/readOnly/actions';
import { taxExemptionsStartRequest } from 'modules/Profile/redux/taxExemptions/actions';
import { getInfo } from 'modules/App/redux/user/actions';

const personalDataRequestActions = {
  personalData: startLoadPersonalData,
  avatar: getAvatar,
  readOnly: startReadOnlyRequest,
  taxExemptions: taxExemptionsStartRequest,
  userInfo: getInfo,
};

function* personaDataPageInitWorker() {
  const requiredData = yield select(dataToLoadPersonalData);
  yield all(
    map(requiredData, (slice, name) => {
      if (isNil(slice.get('data')) && !slice.get('loading')) {
        return put(personalDataRequestActions[name]());
      }
    }),
  );
}

export default function* personaDataPageSaga() {
  yield takeLatest(actionTypes.PERSONAL_DATA_PAGE_INIT, personaDataPageInitWorker);
}
